<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-truck text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Transportadoras</h4>
            <small class="text-muted small">Gerenciamento de transportadoras</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <div style="min-width: 250px">
                        <b-form-input 
                            v-model="textoPesquisa" 
                            placeholder="Buscar por nome, CGC..."
                            class="shadow-xs" 
                            style="font-size: 0.9rem;"
                            @keydown.enter.native="pesquisar()">
                        </b-form-input>
                    </div>
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-1"></i>
              <span class="d-none d-sm-inline">Nova Transportadora</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="3">
                      <label class="small font-weight-bold text-muted">Status</label>
                      <b-form-select v-model="status" class="shadow-xs">
                        <b-form-select-option :value="null">Todos</b-form-select-option>
                        <b-form-select-option value="1">Ativo</b-form-select-option>
                        <b-form-select-option value="0">Inativo</b-form-select-option>
                      </b-form-select>
                    </b-col>
                    <b-col md="3">
                      <label class="small font-weight-bold text-muted">UF</label>
                      <b-form-input v-model="uf" maxlength="2" placeholder="Ex: SP" class="shadow-xs"></b-form-input>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
                    ref="tbl"
                    class="mb-0 table-finance"
                    :head-variant="isDark ? 'dark' : 'light'"
                    :dark="isDark"
                    show-empty
                    empty-text="Nenhuma transportadora encontrada"
                    responsive 
                    :sticky-header="stickyHeight"
                    hover 
                    small
                    :busy.sync="isBusy" 
                    :items="itensFiltrados" 
                    :fields="colunas"
                    :current-page="currentPage"
                    @row-clicked="clicarLinha"
                    :per-page="perPage"
                    @row-dblclicked="edit"
                    :tbody-tr-class="rowClassSelecionado"    
                    >
                  
              <template #head(CODIGO)>
                <SetFilter label="Código" v-model="filtros.CODIGO" :options="opcoes.CODIGO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(NOME)>
                <SetFilter label="Nome/Razão Social" v-model="filtros.NOME" :options="opcoes.NOME" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(CGC)>
                <SetFilter label="CPF/CNPJ" v-model="filtros.CGC" :options="opcoes.CGC" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(UF)>
                <SetFilter label="UF" v-model="filtros.UF" :options="opcoes.UF" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(CIDADE)>
                <SetFilter label="Cidade" v-model="filtros.CIDADE" :options="opcoes.CIDADE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(STATUS)>
                <SetFilter label="Status" v-model="filtros.STATUS" :options="opcoes.STATUS" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              
              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>
              
              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="abrirModalExcluir(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </template>

              <template #cell(STATUS)="row">
                <b-badge :variant="row.item.STATUS === '1' ? 'success' : 'secondary'" pill>
                  {{ row.item.STATUS === '1' ? 'Ativo' : 'Inativo' }}
                </b-badge>
              </template>

              <template #cell(CGC)="row">
                {{ formatarCPFCNPJ(row.item.CGC) }}
              </template>

            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Modal de Confirmação de Exclusão -->
    <b-modal
        ref="modalExcluir"
        title="Confirmar Exclusão"
        ok-variant="danger"
        ok-title="Sim, Excluir"
        cancel-title="Cancelar"
        @ok="excluir"
        centered>
      <div v-if="itemExcluir">
        <p class="mb-3">Deseja realmente excluir esta transportadora?</p>
        <div class="card bg-light">
          <div class="card-body">
            <p class="mb-1"><strong>Código:</strong> {{ itemExcluir.CODIGO }}</p>
            <p class="mb-1"><strong>Nome:</strong> {{ itemExcluir.NOME }}</p>
            <p class="mb-0"><strong>CGC:</strong> {{ formatarCPFCNPJ(itemExcluir.CGC) }}</p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapGetters } from 'vuex'
import { printHtmlReport, exportExcelXlsx, exportCsv } from '@/utils/RelatorioHTML'

export default {
  components: { 
    SetFilter
  },
  mixins: [createCecTableToolsMixin({ rowsProp: 'lista', tblRef: 'tbl', useExternalPaging: false, filters: [
    { key: 'CODIGO', type: 'number', label: 'Código' },
    { key: 'NOME', type: 'string', label: 'Nome' },
    { key: 'CGC', type: 'string', label: 'CGC' },
    { key: 'UF', type: 'string', label: 'UF' },
    { key: 'CIDADE', type: 'string', label: 'Cidade' },
    { key: 'STATUS', type: 'string', label: 'Status' }
  ] })],

  data() {
    return {
      isBusy: false,
      filtroAvancado: false,
      itemExcluir: null,
      colunas: [
        { key: 'CODIGO', label: 'Código', sortable: true, class: 'text-right', thStyle: { width: '100px' } },
        { key: 'NOME', label: 'Nome/Razão Social', sortable: true },
        { key: 'CGC', label: 'CPF/CNPJ', sortable: true, thStyle: { width: '180px' } },
        { key: 'UF', label: 'UF', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'CIDADE', label: 'Cidade', sortable: true, thStyle: { width: '180px' } },
        { key: 'STATUS', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: '100px' } },
        { key: 'actions', label: 'Ações', class: 'text-center', thStyle: { width: '120px' } }
      ]
    }
  }, 

  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    ...mapGetters('transportadora', ['LISTA','TEXTO_PESQUISA','STATUS','UF','REGISTRO_SELECIONADO_ID','RECARREGAR_LISTA']),

    lista: {
      get() { return this.LISTA },
      set(v) { this.$store.commit('transportadora/SET_LISTA', v) }
    },
    textoPesquisa: {
      get() { return this.$store.getters['transportadora/TEXTO_PESQUISA'] },
      set(v) { this.$store.commit('transportadora/SET_TEXTO_PESQUISA', v) }
    },
    status: {
      get() { return this.$store.getters['transportadora/STATUS'] },
      set(v) { this.$store.commit('transportadora/SET_STATUS', v) }
    },
    uf: {
      get() { return this.$store.getters['transportadora/UF'] },
      set(v) { this.$store.commit('transportadora/SET_UF', v) }
    }
  },

  methods: {
    clicarLinha(item) { this.$store.commit('transportadora/SET_REGISTRO_SELECIONADO_ID', item.CODIGO) },
    rowClassSelecionado(item, type) { 
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['transportadora/REGISTRO_SELECIONADO_ID']
      return item.CODIGO === selId ? 'cec-row-selected' : ''
    },
    
    scrollToSelected() {
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.cec-row-selected')
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 500)
      })
    },

    limparFiltro() {
      this.$store.commit('transportadora/SET_LIMPAR', null);
      this.filtroAvancado = false;
      this.pesquisar()
    },

    novo() {
      this.$router.push('/cadastros/transportadora/add')
    },

    edit(item) {
      if (!item || !item.CODIGO) return
      this.$store.commit('transportadora/SET_REGISTRO_SELECIONADO_ID', item.CODIGO)
      this.$router.push(`/cadastros/transportadora/edit/${item.CODIGO}`)
    },

    async pesquisar() {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.isBusy = true
        
        const payload = {
          textoPesquisa: this.textoPesquisa,
          status: this.status,
          uf: this.uf ? this.uf.toUpperCase() : null
        }

        const response = await this.$http.post('/api/protected/transportadora/pesquisar', payload)
        
        let dados = response.data
        if (dados && dados.data) dados = dados.data
        
        this.$store.commit('transportadora/SET_LISTA', dados)

        // Scroll para o registro selecionado após carregar os dados
        if (this.$store.getters['transportadora/REGISTRO_SELECIONADO_ID']) {
          this.scrollToSelected()
        }

      } catch (err) {
        console.error('Erro ao pesquisar Transportadora:', err)
        this.$bvToast.toast('Erro ao pesquisar registros', { title: 'Erro', variant: 'danger' })
      } finally {
        this.isBusy = false
        this.$store.commit('controle/setAguardando', false)
      }
    },

    abrirModalExcluir(item) {
      this.itemExcluir = item
      this.$refs.modalExcluir.show()
    },

    async excluir() {
      if (!this.itemExcluir) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        const payload = {
          id: this.itemExcluir.CODIGO,
          login: window.localStorage.getItem('login') || 'sistema'
        }

        await this.$http.post('/api/protected/transportadora/delete', payload)
        
        this.$bvToast.toast('Registro excluído com sucesso', { title: 'Sucesso', variant: 'success' })
        this.itemExcluir = null
        this.pesquisar()

      } catch (err) {
        console.error('Erro ao excluir Transportadora:', err)
        this.$bvToast.toast('Erro ao excluir registro', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    formatarCPFCNPJ(valor) {
      if (!valor) return '-'
      const numeros = valor.replace(/\D/g, '')
      if (numeros.length === 11) {
        // CPF: 000.000.000-00
        return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      } else if (numeros.length === 14) {
        // CNPJ: 00.000.000/0000-00
        return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      }
      return valor
    },

    exportarHtml() { 
      printHtmlReport({ 
        rows: this.lista, 
        columns: this.colunas, 
        systemName: 'CECWeb', 
        reportTitle: 'Listagem de Transportadoras', 
        printedBy: window.localStorage.getItem('login') ?? '—' 
      }) 
    },
    exportarExcel() { 
      exportExcelXlsx({ 
        rows: this.lista, 
        columns: this.colunas, 
        filename: 'transportadora-lista.xlsx' 
      }) 
    }
  },

  async created() {
    if (this.RECARREGAR_LISTA || !this.LISTA || this.LISTA.length === 0) {
      this.$store.commit('transportadora/SET_RECARREGAR_LISTA', false)
      await this.pesquisar()
    } else {
      // Se não precisou recarregar mas tem um registro selecionado, fazer scroll
      if (this.REGISTRO_SELECIONADO_ID) {
        this.$nextTick(() => {
          this.scrollToSelected()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* Scoped styles if needed */
</style>



// WEBPACK FOOTER //
// src/views/cadastros/transportadora/TransportadoraListagem.vue